import { configureStore } from "@reduxjs/toolkit";
import { Appreducer } from "./reducers";
export const store = configureStore({
  reducer: Appreducer,
});
